import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadEventos, loadtabla } from "../../constants/logistica";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import DataTable from 'react-data-table-component';


const Tracking = () => {
  const today = new Date();
  const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  const location = useLocation();
  
  const [fechaDesde, setFechaDesde] = useState(formattedDate);
  const [fechaHasta, setFechaHasta] = useState(formattedDate);
  const [columnasDisponibles, setColumnasDisponibles] = useState([]);
  const [seleccionadas, setSeleccionadas] = useState([]);
  const [seleccion, setSeleccion] = useState([]);
  const [seleccionadoParaOrdenar, setSeleccionadoParaOrdenar] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [modoBusqueda, setModoBusqueda] = useState('contiene');
  const [porMes, setPorMes] = useState(false);
  const [filtroTabla, setFiltroTabla] = useState('');
  const [tablaData, setTablaData] = useState(null);
  

  useEffect(() => {
    const cargarEventos = async () => {
      const eventos = await loadEventos();
      const columnas = eventos.map(e => ({ id: e.id, descripcion: e.descripcion }));
  
      // Columnas fijas que queremos siempre al principio
      const columnasFijas = [
        { id: 'nrocli', descripcion: 'Cliente' },
        { id: 'sku', descripcion: 'Producto' },
        { id: 'ocompra', descripcion: 'Orden de compra' },
      ];
  
      // Combinar, evitando duplicados si existieran (por si loadEventos trae estas columnas)
      const idsFijos = columnasFijas.map(c => c.id);
      const columnasFiltradas = columnas.filter(c => !idsFijos.includes(c.id));
  
      setColumnasDisponibles([...columnasFijas, ...columnasFiltradas]);
    };
    cargarEventos();
  }, []);
  

  const handleFiltrar = () => {
    const contiene_igual = modoBusqueda === 'contiene' ? 1 : 0;
    const loggedUserData = JSON.parse(localStorage.getItem("user")) || {};
    const nrocli = loggedUserData?.data?.cliente?.nrocli || '';  
    const columnasSeleccionadas = [...seleccionadas.map(c => c.id)];
   
    const filtros = {
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta,
      contiene_igual,
      por_mes: porMes ? 1 : 0, 
      columnas: columnasSeleccionadas, 
      busqueda,
    };
    loadtabla(filtros)
      .then(respuesta => {
        console.log("Datos cargados:", respuesta);
        if(respuesta.status) {
          setTablaData(respuesta);  // Guardamos la data para mostrar
        } else {
          setTablaData(null);
          alert('No se encontraron datos');
        }
      })
      .catch(err => {
        console.error("Error cargando tabla:", err);
        setTablaData(null);
      });
  };

  const moverADerecha = () => {
    const nuevas = seleccion.filter(col => !seleccionadas.includes(col));
    setSeleccionadas([...seleccionadas, ...nuevas]);
    setColumnasDisponibles(columnasDisponibles.filter(col => !nuevas.includes(col)));
    setSeleccion([]);
  };

  const moverAIzquierda = () => {
    const nuevas = seleccion.filter(col => !columnasDisponibles.includes(col));
    setColumnasDisponibles([...columnasDisponibles, ...nuevas]);
    setSeleccionadas(seleccionadas.filter(col => !nuevas.includes(col)));
    setSeleccion([]);
  };

  const moverArriba = () => {
    const idx = seleccionadas.indexOf(seleccionadoParaOrdenar);
    if (idx > 0) {
      const nuevas = [...seleccionadas];
      [nuevas[idx - 1], nuevas[idx]] = [nuevas[idx], nuevas[idx - 1]];
      setSeleccionadas(nuevas);
    }
  };

  const moverAbajo = () => {
    const idx = seleccionadas.indexOf(seleccionadoParaOrdenar);
    if (idx !== -1 && idx < seleccionadas.length - 1) {
      const nuevas = [...seleccionadas];
      [nuevas[idx], nuevas[idx + 1]] = [nuevas[idx + 1], nuevas[idx]];
      setSeleccionadas(nuevas);
    }
  };

  const manejarSeleccion = (col) => {
    setSeleccion(prev =>
      prev.includes(col)
        ? prev.filter(item => item !== col)
        : [...prev, col]
    );
  };

  const estaSeleccionado = (col) => seleccion.includes(col);

  const columnasFiltradas = columnasDisponibles.filter(col => {
    const texto = col.descripcion.toLowerCase();
    const valorBusqueda = busqueda.toLowerCase();
    if (modoBusqueda === 'igual') return texto === valorBusqueda;
    return texto.includes(valorBusqueda);
  });
  

  const togglePorMes = () => setPorMes(prev => !prev);

  const exportarExcel = () => { 
    if (!tablaData?.data || tablaData.data.length === 0) {
      alert("No hay datos para exportar");
      return;
    }
  
    // Crear las filas para el Excel: primero con los títulos
    const titulos = tablaData.titulos;
  
    // Formatear los datos usando esos títulos como claves
    const datos = tablaData.data.map(fila => {
      const nuevaFila = {};
      titulos.forEach(titulo => {
        nuevaFila[titulo] = fila[titulo] ?? ""; // si no existe la propiedad, se pone vacío
      });
      return nuevaFila;
    });
  
    const ws = XLSX.utils.json_to_sheet(datos, { header: titulos });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Datos");
  
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "datos.xlsx");
  };
  
  const datosFiltrados = tablaData?.data?.filter((fila) => {
    const texto = filtroTabla.toLowerCase();
    return Object.values(fila).some(valor =>
      String(valor).toLowerCase().includes(texto)
    );
  }) || [];

  
  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Fechas */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div>
          <label className="block mb-1 font-medium text-gray-700">Fecha Desde</label>
          <input
            type="date"
            value={fechaDesde}
            onChange={(e) => setFechaDesde(e.target.value)}
            className="w-full border rounded px-3 py-2 shadow-sm focus:outline-none focus:ring focus:border-blue-300"
          />
        </div>
        <div>
          <label className="block mb-1 font-medium text-gray-700">Fecha Hasta</label>
          <input
            type="date"
            value={fechaHasta}
            onChange={(e) => setFechaHasta(e.target.value)}
            className="w-full border rounded px-3 py-2 shadow-sm focus:outline-none focus:ring focus:border-blue-300"
          />
        </div>
      </div>

      {/* Selección de columnas */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* 1. Columnas disponibles */}
        <div>
          <h2 className="text-lg font-semibold mb-2">Columnas Disponibles</h2>
          <div className="border rounded max-h-64 overflow-auto text-sm">
          {columnasFiltradas.map((col, idx) => (
  <div
    key={col.id}
    onClick={() => manejarSeleccion(col)}
    onDoubleClick={() => {
      if (!seleccionadas.find(c => c.id === col.id)) {
        setSeleccionadas([...seleccionadas, col]);
        setColumnasDisponibles(columnasDisponibles.filter(c => c.id !== col.id));
        setSeleccion([]);
      }
    }}
    className={`px-3 py-2 cursor-pointer whitespace-nowrap ${
      estaSeleccionado(col) ? 'bg-blue-100 font-semibold' : ''
    }`}
  >
    {col.descripcion}
  </div>
))}

          </div>
        </div>

        {/* 2. Botones mover */}
        <div className="flex flex-col items-center justify-center space-y-4">
          <button
            onClick={moverADerecha}
            className="bg-blue-500 text-white px-5 py-2 rounded hover:bg-blue-600 transition"
          >
            &gt;&gt;
          </button>
          <button
            onClick={moverAIzquierda}
            className="bg-gray-500 text-white px-5 py-2 rounded hover:bg-gray-600 transition"
          >
            &lt;&lt;
          </button>
        </div>

        {/* 3. Columnas seleccionadas */}
        <div>
          <h2 className="text-lg font-semibold mb-2">Columnas Seleccionadas</h2>
          <div className="border rounded max-h-64 overflow-auto text-sm">
          {seleccionadas.map((col) => (
  <div
    key={col.id}
    onClick={() => {
      manejarSeleccion(col);
      setSeleccionadoParaOrdenar(col);
    }}
    onDoubleClick={() => {
      if (!columnasDisponibles.find(c => c.id === col.id)) {
        setColumnasDisponibles([...columnasDisponibles, col]);
        setSeleccionadas(seleccionadas.filter(c => c.id !== col.id));
        setSeleccion([]);
      }
    }}
    className={`px-3 py-2 cursor-pointer whitespace-nowrap ${
      estaSeleccionado(col) ? 'bg-green-100 font-semibold' : ''
    } ${col === seleccionadoParaOrdenar ? 'border border-green-600' : ''}`}
  >
    {col.descripcion}
  </div>
))}

          </div>
        </div>

        {/* 4. Botones ordenar */}
        <div className="flex flex-col items-start justify-start space-y-2 pt-8">
          <button
            onClick={moverArriba}
            className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300 text-sm"
          >
            ↑ Mover Arriba
          </button>
          <button
            onClick={moverAbajo}
            className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300 text-sm"
          >
            ↓ Mover Abajo
          </button>
        </div>
      </div>

      {/* Filtros */}
      <div className="flex flex-col md:flex-row justify-center items-start md:items-center gap-6 mt-6 text-sm text-gray-700 text-center w-full">
        <div className="flex flex-col items-center">
          <div className="flex space-x-4 mb-2">
            <label className="flex items-center space-x-1">
              <input
                type="radio"
                name="modoBusqueda"
                value="igual"
                checked={modoBusqueda === 'igual'}
                onChange={() => setModoBusqueda('igual')}
              />
              <span>Igual a</span>
            </label>
            <label className="flex items-center space-x-1">
              <input
                type="radio"
                name="modoBusqueda"
                value="contiene"
                checked={modoBusqueda === 'contiene'}
                onChange={() => setModoBusqueda('contiene')}
              />
              <span>Contiene</span>
            </label>
          </div>
          <input
            type="text"
            placeholder="Buscar..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            className="border rounded px-3 py-1 w-64"
          />
        </div>

        <div className="flex flex-wrap justify-center gap-4">
          <label className="flex items-center space-x-1">
            <input
              type="checkbox"
              checked={porMes}
              onChange={togglePorMes}
            />
            <span>Por Mes</span>
          </label>
        </div>

        <div>
          <button
            onClick={handleFiltrar}
            className="bg-blue-600 text-white px-10 py-2 rounded hover:bg-blue-700"
          >
            Filtrar
          </button>
        </div>
      </div>

       {/* Tabla con los datos */}
      {tablaData && tablaData.data && tablaData.data.length > 0 && (
        <div className="mt-8 overflow-auto">
          
    {/* Botón de exportación */}
    <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-4">
  <input
    type="text"
    placeholder="Buscar en la tabla..."
    value={filtroTabla}
    onChange={(e) => setFiltroTabla(e.target.value)}
    className="w-full md:w-1/3 border rounded px-3 py-2 shadow-sm focus:outline-none focus:ring focus:border-blue-300"
  />

  <button
    onClick={exportarExcel}
    className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
  >
    Exportar a Excel
  </button>
</div>

<DataTable
  columns={tablaData.titulos.map((titulo) => ({
    name: titulo,
    selector: row =>
      titulo === "Cantidad" ? Number(row[titulo]) : row[titulo],
    sortable: true,
    right: titulo === "Cantidad", // 👈 Alinea a la derecha si es "Cantidad"
  }))}
  data={datosFiltrados}
  pagination
  highlightOnHover
  striped
  dense
/>


        </div>
      )}  
    </div>
  );
};

export default Tracking;
